module.exports = __webpack_public_path__ + "static/media/background-download.ce339148.png";